module.exports = __webpack_public_path__ + "static/media/Mohammadmehdi Ataei.fafab53b.png";